import { getLevelArrayMetric as r } from "../index4.js";
import { getLevelResidentialEfficiency as i } from "../level-metrics/index29.js";
const f = (e) => r(e, i);
export {
  f as getLevelArrayResidentialEfficiency
};
//# sourceMappingURL=index15.js.map
